import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentPath } from '@service-initiation/shared-data-access-flow-manager';
import { useAsyncAtom } from '@service-initiation/shared-utils-jotai';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import { selectedAppointmentAsyncAtom } from '@service-initiation/tech-care-data-access-store';
import {
  formatDate,
  formatTime,
} from '@service-initiation/tech-care-utils-date-time';

import {
  PrimaryText,
  SecondaryText,
  VisitDetailsListItem,
} from '../components';

const TEXT = TranslationEntries.Repairs.Cart.VisitDetails;

export const AppointmentTimeSummaryItem: FC = () => {
  const { t } = useTranslation();
  const currentPath = useCurrentPath();
  const { value: appointment } = useAsyncAtom(selectedAppointmentAsyncAtom);
  const appointmentStartTime = appointment?.startTime;
  const appointmentEndTime = appointment?.endTime;
  const appointmentDate = appointment?.date;
  const appointmentIsAsap = appointment?.isAsap;
  const isAppointmentSet = !!appointmentStartTime || appointmentIsAsap === true;

  return (
    <VisitDetailsListItem
      active={currentPath === Route.AppointmentTime || isAppointmentSet}
      iconSrc="time"
      linkTo="AppointmentTime"
      title={t(TEXT.DateTimeText)}
    >
      {isAppointmentSet &&
        (!appointmentIsAsap &&
        appointmentStartTime &&
        appointmentEndTime &&
        appointmentDate ? (
          <PrimaryText>
            {formatTime(appointmentStartTime, appointmentEndTime)}
            <SecondaryText>
              <br />
              {formatDate(appointmentDate)}
            </SecondaryText>
          </PrimaryText>
        ) : (
          <PrimaryText>{t(TEXT.PrimaryAsapText)}</PrimaryText>
        ))}
    </VisitDetailsListItem>
  );
};
